import CoreColors from "./palettes/core-colors"
import {ChartColors} from "./chart/chart-colors"
import ProjectColorsPalette from "./palettes/project-palette"
import Skin, {SkinTheme} from "../skin"
import {ColorPalette, ItemColorCoding} from "../../../fields3/color-coding/color-coding"
import {CoreLightBorderPalette, CoreLightPalette} from "./palettes/contrast-light/core"
import {StatusLightBorderPalette, StatusLightPalette} from "./palettes/contrast-light/status"
import {PriorityLightBorderPalette, PriorityLightPalette} from "./palettes/contrast-light/priority"
import {SystemLightBorderPalette, SystemLightPalette} from "./palettes/contrast-light/system"
import {CoreMainBorderPalette, CoreMainPalette} from "./palettes/main/core"
import {StatusMainBorderPalette, StatusMainPalette} from "./palettes/main/status"
import {SystemMainBorderPalette, SystemMainPalette} from "./palettes/main/system"
import {PriorityMainBorderPalette, PriorityMainPalette} from "./palettes/main/priority"
import {
    ColorPalette_NavigationBG_Light,
    ColorPalette_NavigationBGDark_Light,
    ColorPalette_NavigationSelected_Light
} from "./palettes/navigation/bg/light"
import {
    ColorPalette_NavigationBG_Dark,
    ColorPalette_NavigationBGDark_Dark,
    ColorPalette_NavigationSelected_Dark
} from "./palettes/navigation/bg/dark"
import {CorePaleBorderPalette, CorePalePalette} from "./palettes/pale/core"
import {PriorityPaleBorderPalette, PriorityPalePalette} from "./palettes/pale/priority"
import {StatusPaleBorderPalette, StatusPalePalette} from "./palettes/pale/status"
import {SystemPaleBorderPalette, SystemPalePalette} from "./palettes/pale/system"

// const debug = false
const debug = "SkinColors"

export class SkinColors {

    protected skin:Skin

    constructor(skin:Skin) {
        this.skin = skin
    }

    navigationBG():string {

        const skinColor = gd.user.settings.skin.navigation

        let color : string = '#FF0000'

        switch (this.skin.currentSkin) {
            case SkinTheme.DARK:
                color = _.get(ColorPalette_NavigationBG_Dark, skinColor, color)
                break

            case SkinTheme.LIGHT:
            default:
                color = _.get(ColorPalette_NavigationBG_Light, skinColor, color)
                break;
        }

        return color
    }

    navigationBGDark():string {

        const skinColor = gd.user.settings.skin.navigation

        let color : string = '#FF0000'

        switch (this.skin.currentSkin) {
            case SkinTheme.DARK:
                color = _.get(ColorPalette_NavigationBGDark_Dark, skinColor, color)
                break

            case SkinTheme.LIGHT:
            default:
                color = _.get(ColorPalette_NavigationBGDark_Light, skinColor, color)
                break;
        }

        return color
    }

    navigationSelected():string {

        const skinColor = gd.user.settings.skin.navigation

        let color : string = '#FF0000'

        switch (this.skin.currentSkin) {
            case SkinTheme.DARK:
                color = _.get(ColorPalette_NavigationSelected_Dark, skinColor, color)
                break

            case SkinTheme.LIGHT:
            default:
                color = _.get(ColorPalette_NavigationSelected_Light, skinColor, color)
                break;
        }

        return color
    }

    // ie. font
    mainColor(colorCoding: ItemColorCoding):string {
        switch (colorCoding.corePalette) {
            case ColorPalette.CORE       : return CoreMainPalette[colorCoding.colorNumber]
            case ColorPalette.PRIORITY   : return PriorityMainPalette[colorCoding.colorNumber]
            case ColorPalette.STATUS     : return StatusMainPalette[colorCoding.colorNumber]
            case ColorPalette.SYSTEM     : return SystemMainPalette[colorCoding.colorNumber]
            case ColorPalette.GRAY       : return this.skin.grayPalette?.getColorHEX(colorCoding.colorNumber) || ''
        }

        return '#FF0000'
    }

    mainBorderColor(colorCoding: ItemColorCoding):string {
        switch (colorCoding.corePalette) {
            case ColorPalette.CORE       : return CoreMainBorderPalette[colorCoding.colorNumber]
            case ColorPalette.PRIORITY   : return PriorityMainBorderPalette[colorCoding.colorNumber]
            case ColorPalette.STATUS     : return StatusMainBorderPalette[colorCoding.colorNumber]
            case ColorPalette.SYSTEM     : return SystemMainBorderPalette[colorCoding.colorNumber]
            case ColorPalette.GRAY       : return this.skin.grayPalette?.getColorHEX(colorCoding.colorNumber) || ''
        }

        return '#FF0000'
    }

    lightColor(colorCoding: ItemColorCoding):string {
        switch (colorCoding.corePalette) {
            case ColorPalette.CORE       : return CoreLightPalette[colorCoding.colorNumber]
            case ColorPalette.PRIORITY   : return PriorityLightPalette[colorCoding.colorNumber]
            case ColorPalette.STATUS     : return StatusLightPalette[colorCoding.colorNumber]
            case ColorPalette.SYSTEM     : return SystemLightPalette[colorCoding.colorNumber]
            case ColorPalette.GRAY       : return this.skin.grayPalette?.getColorHEX(colorCoding.colorNumber) || ''
        }

        return '#FF0000'
    }

    lightBorderColor(colorCoding: ItemColorCoding):string {
        switch (colorCoding.corePalette) {
            case ColorPalette.CORE       : return CoreLightBorderPalette[colorCoding.colorNumber]
            case ColorPalette.PRIORITY   : return PriorityLightBorderPalette[colorCoding.colorNumber]
            case ColorPalette.STATUS     : return StatusLightBorderPalette[colorCoding.colorNumber]
            case ColorPalette.SYSTEM     : return SystemLightBorderPalette[colorCoding.colorNumber]
            case ColorPalette.GRAY       : return this.skin.grayPalette?.getColorHEX(colorCoding.colorNumber) || ''
        }

        return '#FF0000'
    }

    // should be overridden
    paleBGColor(colorCoding: ItemColorCoding):string {
        return '#FF0000'
    }

    paleColor(colorCoding: ItemColorCoding):string {
        switch (colorCoding.corePalette) {
            case ColorPalette.CORE       : return CorePalePalette[colorCoding.colorNumber]
            case ColorPalette.PRIORITY   : return PriorityPalePalette[colorCoding.colorNumber]
            case ColorPalette.STATUS     : return StatusPalePalette[colorCoding.colorNumber]
            case ColorPalette.SYSTEM     : return SystemPalePalette[colorCoding.colorNumber]
            case ColorPalette.GRAY       : return this.skin.grayPalette?.getColorHEX(colorCoding.colorNumber) || ''
        }

        return '#FF0000'
    }

    paleBorderColor(colorCoding: ItemColorCoding):string {
        switch (colorCoding.corePalette) {
            case ColorPalette.CORE       : return CorePaleBorderPalette[colorCoding.colorNumber]
            case ColorPalette.PRIORITY   : return PriorityPaleBorderPalette[colorCoding.colorNumber]
            case ColorPalette.STATUS     : return StatusPaleBorderPalette[colorCoding.colorNumber]
            case ColorPalette.SYSTEM     : return SystemPaleBorderPalette[colorCoding.colorNumber]
            case ColorPalette.GRAY       : return this.skin.grayPalette?.getColorHEX(colorCoding.colorNumber) || ''
        }

        return '#FF0000'
    }

    get ui5Highlight():string {
        return "#7E8B9812" // rgba(126, 139, 152, 0.07)
    }

    get actionColor():string {
        return "#1970ff" // $palette-system-action: #1970ff;
    }

    get coreColorsPalette() {
        return CoreColors
    }

    get projectColorsPalette() {
        return ProjectColorsPalette
    }

    get chartColors(): ChartColors {
        return {
            defaultColor                : this.skin.grayPalette ? this.skin.grayPalette.getColorHEX(9) : '#7E8B98',
            gridLineColor               : this.skin.grayPalette ? this.skin.grayPalette.getColorHEX(5) : '#ECf0F3', // default color because there is no gray pallete in dark mode
            tickLabelColor              : '#787B80',

            burnUpTotalColor            : '#000000',
            burnPlanningLineColor       : '#d5d9de',
            burnPlanningLabelColor      : '#000000',
            burnPlanningLabelHaloColor  : '#000000',

            pieStrokeColor              : '#ffffff',

            averageLineColor            : '#FF493D',

            numberOfTasksColor          : '#3DB051',
            estimatedColor              : '#3D96FF',
            storyPointsColor            : '#E85169',
        }
    }

    getCoreColorHEX(index: number): string {
        let palette: string[] = this.coreColorsPalette
        return palette[index]
    }

    getProjectColorPaletteHEX(index: number): string {
        let palette: string[] = this.projectColorsPalette
        const paletteIndex = index % palette.length // if index is more than palette length then take from the start again
        return palette[paletteIndex]
    }
}
